import { ResultProcess } from './models/resultProcess';
import { Component, OnInit } from '@angular/core';
import { LabMDM } from './models/lab';
import { CarrierState } from './models/carrierState';
import { Machine } from './models/machine';
import { BusinessArea } from './models/businessArea';
import { MasterDataService } from './masterdata.service';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { MasterList } from './masterList-enum';
import { SeqConfig } from './models/seqConfig';
import { SelectItem } from 'primeng/components/common/selectitem';
import { Chemical } from './models/chemical';
import { SelectableHazardousType } from './selectable-hazardoustype';
import { SelectableAssayType } from './models//SelectableAssayType';
import { AssayType } from './models/assayType-enum';
import { HazardousType } from './hazardousType-enum';
import { Printer } from './models/printer';
import { MachineType } from './models/machineType';
import { Product } from './models/product';
import { BmsProductName } from './models/BmsProductName';
import { SelectableProcessStep } from './models/SelectableProcessStep';
import { ProcessStep } from './models/processStep-enum';
import { LibType } from './models/libType';
import { EchoConfig } from './models/echoConfig';
import { SalesItemTypeConfig } from './models/salesitemtype-config';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ProblemCategoryDTO } from './models/problemCategory';
import { ProblemDTO } from './models/problem';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { ResultConfigDTO } from '../mdm-result-engine-config/model/result-config-dto';
import { ExternalSenderLoginDTO } from './models/externalSenderLogin';
import { Manufacturers } from './models/manufacturers';
import { RedoReason } from './models/redoReason';
import { InboundFileProcessing } from './models/inboundFileProcessing';
import { WorkFlow } from './models/workFlow';
import { Controls } from './models/controls';
import { BatchStatus } from './models/batchStatus';
import { ParentageAnalysis } from './models/parentage';



@Component({
  selector: 'app-masterdata',
  templateUrl: './masterdata.component.html',
  styleUrls: ['./masterdata.component.css']
})
//This component is used to display the various lisst of master data. This is the parent of the crud table component.
//The data regarding the feilds to disaply in the crud table is sent to the child component.
export class MasterdataComponent implements OnInit {

  countries: SelectItem[];
  statusCols: any[];
  labCols: any[];
  machineCols: any[];
  printerCols: any[];
  baCols: any[];
  seqConfigCols: any[];
  chemicalCols: any[];
  machineTypesCols: any[];
  productCols: any[];
  accessLogsCols: any[];
  libTypeCols: any[];
  echoConfigCols: any[];
  sitConfigCols: any[];
  standardPrimerCols: any[];
  templateCols: any[];
  senderCols: any[];
  kitCols: any[] = [];
  kitDetailCols: any[] = [];
  labs: LabMDM[] = [];
  machines: Machine[] = [];
  printers: Printer[] = [];
  states: CarrierState[] = [];
  businessAreas: BusinessArea[] = [];
  seqConfigs: SeqConfig[] = [];
  chemicals: Chemical[] = [];
  machineTypes: MachineType[];
  products: Product[] = [];
  libTypes: LibType[] = [];
  echoConfigs: EchoConfig[] = [];
  sitConfigs: SalesItemTypeConfig[] = [];
  standardPrimers: StandardPrimer[] = [];
  templates: Template[] = [];
  senders: SenderDTO[] = [];
  kits: KitsDTO[] = [];
  problemCategories: ProblemCategoryDTO[] = [];
  problemCategoriesCols: any[];
  resultProcessCols: any[];
  resultEngineConfigCols: any[];
  problem: ProblemDTO[] = [];
  resultProcess: ResultProcess[] = [];
  resultConfigList: ResultConfigDTO[] = [];
  problemCols: any[];
  labTitle: string = "Labs";
  machineTitle: string = "Machines";
  printerTitle: string = "Printers";
  processStepTitle: string = "Process Step";
  baTitle: string = "Business Areas";
  seqConfigTitle: string = "Sequencer Configurations";
  chemicalTitle: string = "Chemicals";
  machineTypesTitle: string = "Machine Types"
  productTitle: string = "Products"
  libTypeTitle: string = "LibTypes"
  echoConfigTitle: string = "Echo Configurations";
  sitConfigTitle: string = "Sales Item Types";
  standardPrimerTitle: string = "Standard Primers";
  templateTitle: string = "Barcode Templates";
  senderTitle: string = "Sender Templates";
  kitsTitle: string = "Kits Configuration"
  problemCategoryTitle: string = "Problem Category "
  problemTitle: string = "NC-Problem"
  resultProcessTitle: string = "Result-Process"
  resultEngineConfigTitle: string = "Result Logic"
  redoReasonTitle: string = "Redo Reason";
  inboundFileProcessingTitle: string = 'Inbound File Processing';
  labType = MasterList.LAB;
  machineType = MasterList.MACHINE;
  printerType = MasterList.PRINTER;
  baType = MasterList.BUSINESS_AREA;
  statusType = MasterList.CARRIER_STATUS;
  seqConfigType = MasterList.SEQUENCER_CONFIG;
  chemicalType = MasterList.CHEMICAL;
  machineTypeList = MasterList.MACHINE_TYPE;
  productType = MasterList.PRODUCT;
  libType = MasterList.LIB_TYPE;
  echoConfigType = MasterList.ECHO_CONFIGURATION;
  sitConfigType = MasterList.SALES_ITEM_TYPE;
  
  labOptions: LabMDM[] = [];
  baOptions: BusinessArea[] = [];
  machineTypesOptions: MachineType[] = [];
  hazardousTypeOptions: SelectableHazardousType[] = [];
  assayTypeOptions: SelectableAssayType[] = [];
  errorHandler: ErrorHandler = new ErrorHandler;

  bufferChemicalOptions: Chemical[];
  sitConfigOptions: SalesItemTypeConfig[] = [];
  bmsProductNames: BmsProductName[] = [];
  printerOptions: Printer[] = [];
  processStepOptions: SelectableProcessStep[];
  productOptions: Product[] = [];
  templateOptions: Template[] = [];
  

  loading: boolean;
  respose: any;
  health: any;
  healthCols: any[];
  accessLog: any;
  selectedLab: SelectableLab;
  
  maxRedoValues: SelectItem[];
  reactionOptionValues: SelectItem[];
  //Config for Machine Manufacturer Config
  manufacturerConfigTitle ="Machine Manufacturer";
  manufacturerConfigCols:any[];
  manufacturersList: Manufacturers[];

  externalSenderLogins: ExternalSenderLoginDTO[];
  externalSenderLoginTitle: string = "External Sender Login Templates";
  externalSenderLoginCols: any[];
  redoReasons: Array<RedoReason>;
  redoReasonCols: Array<any>
  inboundFileProcessing: Array<InboundFileProcessing>;
  inboundFileProcessingCols: Array<any>;

  workFlowTitle: string = 'Work Flow';
  workFlow:WorkFlow[];
  workFlowCols: Array<any>;

  controlTitle: string = 'Controls'; 
  controlType= 'controls';
  controls: Controls[] = [];
  controlProcessingCols: Array<any>;

  batchStatusTitle: string="BatchStatus";
  batchStatus: BatchStatus[];
  batchStatusType='batchstatus';
  batchStatusCols: Array<any>;
  
  parentageAnalysisTitle: string="STR Parentage Analysis";
  parentageAnalysis:ParentageAnalysis[];
  parentageAnalysisType:'parentageAnalysis';
  parentageAnalysisCols: Array<any>;
  

  constructor(private _masterDataService: MasterDataService, private _messageService: MessagesService
              , private _labEmitterService: LabEmitterService) {

  }

  ngOnInit() {

  this._labEmitterService.change.subscribe(lab => {
      this.selectedLab = lab;
      console.log("Seleted lab in masterData(e): " + this.selectedLab.label)
  });
  this.selectedLab = JSON.parse(localStorage.getItem('lab'));

    //Used for displaying the lab values in the crud table
    this.labCols = [
      { field: 'name', header: 'Lab Name' },
      { field: 'mix2SeqLabId', header: 'Mix2Seq Lab ID' },
      { field: 'productionLab', header: 'One-IT Lab ID (BMS compatible)' },
      { field: 'businessArea', header: 'BusinessArea', sort: 'businessArea.name' },
      { field: 'countryName', header: 'Country' },
      { field: 'city', header: 'City' },
      { field: 'numberOfPC', header: 'Number Of PC' },
      { field: 'numberOfNC', header: 'Number Of NC' },
      { field: 'numberOfPositivePCRControls', header: 'Number positive PCR Controls ', display: 'none' },
      { field: 'numberOfNegativePCRControls', header: 'Number negative PCR Controls', display: 'none' },
      { field: 'manager', header: 'Lab Manager' },
      { field: 'defaultLanguage', header: 'Default Language' },
      { field: 'unboxingInBatches', header: 'Unboxing in batches' ,display: 'none'},
      { field: 'reportingOutsideBB', header: 'Reporting done outside BB', display: 'none' },
      { field: 'resultReportPerSender', header: 'Create Result Report Per Sender', display: 'none' },
      { field: 'clippingMachine', header: 'Clipping Machine (create batch by upload)', display: 'none' },
      { field: 'reducedConfirmationTests', header: 'Reduced Confirmation Tests', display: 'none' },
      { field: 'flaTestProcess', header: 'FLA Process', display: 'none' },
      { field: 'batchIDRegex', header: 'Check BatchID with regex', display: 'none' },
      { field: 'active', header: 'Active' }
    ];
    //Used for displaying manufacturer config values
    this.manufacturerConfigCols = [
      { field: 'manufacturerName', header: 'Name' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'active', header: 'Active'}
    ];
    //Used for displaying the machine values in the crud table
    this.machineCols = [
      { field: 'name', header: 'Name' },
      { field: 'barcode', header: 'Barcode' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'type', header: 'Machine Type', sort: 'type.name', onChangeEvent: true },
      { field: 'manufacturer', header: 'Manufacturer' },
      { field: 'hostAddress', header: 'Host Address', width: '20%' },
      { field: 'subType', header: 'Sub Type' },
      { field: 'fileType', header: 'File Type' },
      { field: 'ioCapacity', header: 'In/Out Capacity' },
      { field: 'active', header: 'Active', width: '5%' }
    ];
    //Used for displaying the printer values in the crud table
    this.printerCols = [
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'name', header: 'Name' },
      { field: 'hostAddress', header: 'Host Address' },
      { field: 'port', header: 'Port' },
      { field: 'printEnabled', header: 'Print Enabled' },
      { field: 'defaultPrinter', header: 'Default Printer' },
      { field: 'active', header: 'Active' },
      { field: 'template', header: 'Default Template' }
    ];
    //Used for displaying the status values in the crud table
    this.statusCols = [
      { field: 'name', header: 'Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'printer', header: 'Printer' },
      { field: 'defaultTemplate', header: 'Default Template' },
      { field: 'nextStep', header: 'Next Step' },
      { field: 'processList', header: 'Process List Active' },
      { field: 'platePrefixes', header: 'Plate Prefixes' },
      { field: 'extraField1', header: 'Extra Field1' },
      { field: 'inputCheck1', header: 'input Check1' },
      { field: 'extraField2', header: 'Extra Field2' },
      { field: 'inputCheck2', header: 'input Check2' },
      { field: 'active', header: 'Active' }
    ];
    //Used for displaying the ba values in the crud table
    this.baCols = [
      { field: 'name', header: 'Business Area' },
      { field: 'active', header: 'Active' },
    ];

    //Used for displaying the Seq Config values in the crud table
    this.seqConfigCols = [
      { field: 'description', header: 'Description' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'product', header: 'ProductType' },
      { field: 'application', header: 'Application' },
      { field: 'containerType', header: 'ContainerType' },
      { field: 'owner', header: 'Owner' },
      { field: 'operator', header: 'Operator' },
      { field: 'plateSealing', header: 'PlateSealing' },
      { field: 'resultsGroup', header: 'ResultsGroup' },
      { field: 'instrumentProtocol1', header: 'Instrument Protocol1' },
      { field: 'analysisProtocol1', header: 'Analysis Protocol1' },
      { field: 'active', header: 'Active' }
    ];

    this.chemicalCols = [
      { field: 'name', header: 'Name' },
      { field: 'barcode', header: 'Barcode' },
      { field: 'lab', header: 'Lab' },
      { field: 'originalVolume', header: ' Orignal Volume' },
      { field: 'remainingVolume', header: 'Remaining Volume' },
      { field: 'hazardousType', header: 'Hazardous Type' },
      { field: 'category', header: 'Category' },
      { field: 'active', header: 'Active' },
    ];

    //Used to displaying the product in crude table
    this.productCols = [
      { field: 'name', header: 'Product Type' },
      { field: 'workflow', header: 'Work Flow' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'salesItemType', header: 'Sales Item Type' },
      { field: 'pcrKits', header: 'PCR Kits' },
      { field: 'productMaxRedo', header: 'Max Redo' },
      { field: 'allowExcelUpload', header: 'Allow Excel Upload' },
      { field: 'premixed', header: 'Premixed' },
      { field: 'active', header: 'Active' }
    ];

    //Used for displaying the machine Type values in the crud table
    this.machineTypesCols = [
      { field: 'name', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'liquidHandling', header: 'Liquid Handling' },
      { field: 'measurements', header: 'Measurements' },
      { field: 'scanner', header: 'Scanner' },
      { field: 'active', header: 'Active' },
    ];
    this.healthCols = [
      { field: 'name', header: 'Service' },
      { field: 'healthcheckresult', header: 'Status' }
    ];

    //Used to displaying the product in crude table
    this.libTypeCols = [
      { field: 'name', header: 'Name' },
      { field: 'buffer', header: 'Buffer', sort: 'buffer.name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'targetVolume', header: 'Target Volume' },
      { field: 'minConc', header: 'Min Conc' },
      { field: 'maxConc', header: 'Max Conc' },
      { field: 'assayType', header: 'Assay Type' },
      { field: 'fragmentAnalyserConc', header: 'Fragment Analyser Conc' },
      { field: 'dilution_d', header: 'dilution_d' },
      { field: 'dilution_c', header: 'dilution_c' },
      { field: 'dilution_b', header: 'dilution_b' },
      { field: 'default', header: 'Default' },
      { field: 'active', header: 'Active' },
    ];

    this.hazardousTypeOptions = [
      { label: 'Acute Toxicity', hazardousType: HazardousType.ACUTE_TOXICITY },
      { label: 'Aspiration Hazard', hazardousType: HazardousType.ASPIRATION_HAZARD },
      { label: 'Compressed Gases', hazardousType: HazardousType.COMPRESSED_GASES },
      { label: 'Corrosive', hazardousType: HazardousType.CORROSIVE },
      { label: 'Explosives', hazardousType: HazardousType.EXPLOSIVES },
      { label: 'Flamable Liquids', hazardousType: HazardousType.FLAMMABLE_LIQUIDS },
      // { label: 'Hazardous To Aquatic Environment', hazardousType: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT },
      { label: 'Oxidising Liquids', hazardousType: HazardousType.OXIDISING_LIQUIDS },
      { label: 'Toxic Irration', hazardousType: HazardousType.TOXIC_IRRATION },
    ];

    this.assayTypeOptions = [
      { label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT },
      { label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT },
      { label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT },
      { label: 'No Assay Type', assayType: AssayType.NO_ASSAY_TYPE }
    ];

    this.processStepOptions = [
      { label: ProcessStep.SAMPLE_RECEPTION, processStep: ProcessStep.SAMPLE_RECEPTION },
      { label: ProcessStep.MERGING, processStep: ProcessStep.MERGING },
      { label: ProcessStep.REACTION_MIX, processStep: ProcessStep.REACTION_MIX },
      { label: ProcessStep.THERMAL_CYCLER, processStep: ProcessStep.THERMAL_CYCLER },
      { label: ProcessStep.DT_REMOVAL, processStep: ProcessStep.DT_REMOVAL },
      { label: ProcessStep.SPLITTING, processStep: ProcessStep.SPLITTING },
      { label: ProcessStep.SEQUENCING, processStep: ProcessStep.SEQUENCING },
      { label: ProcessStep.PREPARING, processStep: ProcessStep.PREPARING },
      { label: ProcessStep.REACTIONS_PLACEMENT, processStep: ProcessStep.REACTIONS_PLACEMENT },
      { label: ProcessStep.ENTRY_QC, processStep: ProcessStep.ENTRY_QC },
      { label: ProcessStep.EXTRACTION, processStep: ProcessStep.EXTRACTION },
      { label: ProcessStep.ENTRY_QC_OK, processStep: ProcessStep.ENTRY_QC_OK },
      { label: ProcessStep.LIB_PREP_START, processStep: ProcessStep.LIB_PREP_START },
      { label: ProcessStep.ENRICHMENT, processStep: ProcessStep.ENRICHMENT },
      { label: ProcessStep.FRAGMENTATION, processStep: ProcessStep.FRAGMENTATION },
      { label: ProcessStep.CDNA_SYNTHESIS, processStep: ProcessStep.CDNA_SYNTHESIS },
      { label: ProcessStep.END_REPAIR, processStep: ProcessStep.END_REPAIR },
      { label: ProcessStep.AMPLIFICATION, processStep: ProcessStep.AMPLIFICATION },
      { label: ProcessStep.LIB_QC, processStep: ProcessStep.LIB_QC },
      { label: ProcessStep.LIB_PREP_COMPLETE, processStep: ProcessStep.LIB_PREP_COMPLETE }
    ];
    //used to display the access log values
    this.accessLogsCols = [
      { field: 'puid', header: 'PUID' },
      { field: 'loginTime', header: 'Login Time' },
      { field: 'logoutTime', header: 'Logout Time' }
    ];

    //Used for displaying the Echo Config values in the crud table
    this.echoConfigCols = [
      { field: 'product', header: 'Product Type' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'reactionOptionProtocol', header: 'Reaction options' },
      { field: 'masterMixBarcode', header: 'Master Mix Barcode' },
      { field: 'masterMixPlateType', header: 'Master Mix PlateType' },
      { field: 'masterMixVolume', header: 'Master Mix Volume' },
      { field: 'sourcePlateType', header: 'Source Plate Type' },
      { field: 'sampleVolume', header: 'Sample Volume' },
      { field: 'standardPrimerVolume', header: 'Standard Primer Volume' },
      { field: 'synthesizedPrimerVolume', header: 'Synthesized Primer Volume' },
      { field: 'enclosedPrimerVolume', header: 'Enclosed Primer Volume' },
      { field: 'active', header: 'Active' }
    ];

    this.sitConfigCols = [
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'sitKey', header: 'Sales Item Type' },
      { field: 'bmsKitProductName', header: 'BMS Kit Product Name', sort: 'bmsKitProductName.name' },
      { field: 'bmsTubeProductName', header: 'BMS Tube Product Name', sort: 'bmsKitProductName.name' },
      { field: 'jobTime', header: 'Job Time' },
      { field: 'maxRedo', header: 'Max Redo' }
    ];

    this.standardPrimerCols = [
      { field: 'primerName', header: 'Primer Name' },
      { field: 'sequence', header: 'Sequence' },
      { field: 'primerID', header: 'Primer ID' },
      { field: 'tm', header: 'Tm °C' },
      { field: 'gc', header: 'GC %' },
      { field: 'qcPrimer', header: 'QC Primer' },
      { field: 'active', header: 'Active' }
    ];

    this.templateCols = [
      { field: 'templateName', header: 'Template Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'entity', header: 'Entity' },
      { field: 'width', header: 'Width' },
      { field: 'height', header: 'Height' },
      { field: 'active', header: 'Active' },
    ];


    this.senderCols = [
      { field: 'senderName', header: 'Sender Name', width: '10%' },
      { field: 'senderShortName', header: 'Short Name' },
      { field: 'senderGroupName', header: 'Sender Group Name '},
      { field: 'defaultSender', header: 'Default Sender', width: '4%' },
      { field: 'products', header: 'Products' },
      { field: 'lab', header: 'Lab' },
      { field: 'barcodeFormat', header: 'Barcode Format' },
      { field: 'checkForIdentity', header: 'Check For Identity' },
      { field: 'mergeGroup', header: 'Merge Group' },
      { field: 'barcodeValidationRequired', header: 'DB Exist. Check Req?', width: '4%' },
      { field: 'dataFormat', header: 'Result Report Format' },
      { field: 'contactID', header: 'Contact ID' },
      { field: 'defaultPriority', header: 'Default Priority', width: '4%', display: 'none' },
      { field: 'allowedPCRKits', header: 'Allowed PCR Kits', display: 'none' },
      { field: 'allowedExtractionKits', header: 'Allowed Extractor Kits', display: 'none' },
      { field: 'active', header: 'Active', width: '4%' },
      { field: 'categoryType', header: 'Problem Category', display: 'none' }
    ]

    this.kitCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'lab', header: 'Lab' },
      { field: 'kitType', header: 'Kit Type' },
      { field: 'requiredMaterials', header: 'Required Materials' },
      { field: 'swabRestriction', header: 'Swab Restriction' },
      { field: 'channel1Gene', header: 'Channel 1-Gene' },
      { field: 'channel1File', header: 'Channel 1-File' },
      { field: 'channel1Dye', header: 'Channel 1-Dye' },
      { field: 'channel2Gene', header: 'Channel 2-Gene' },
      { field: 'channel2File', header: 'Channel 2-File' },
      { field: 'channel2Dye', header: 'Channel 2-Dye' },
      { field: 'channel3Gene', header: 'Channel 3-Gene' },
      { field: 'channel3File', header: 'Channel 3-File' },
      { field: 'channel3Dye', header: 'Channel 3-Dye' },
      { field: 'channel4Gene', header: 'Channel 4-Gene' },
      { field: 'channel4File', header: 'Channel 4-File' },
      { field: 'channel4Dye', header: 'Channel 4-Dye' },
      { field: 'channel5Gene', header: 'Channel 5-Gene' },
      { field: 'channel5File', header: 'Channel 5-File' },
      { field: 'channel5Dye', header: 'Channel 5-Dye' },
      { field: 'runProtocol', header: 'Run Protocol' },
      { field: 'dominantChannel', header: 'Dominant Channel' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'active', header: 'Active' }
    ]

    this.kitDetailCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'lab', header: 'Lab' },
      { field: 'kitType', header: 'Kit Type' },
      { field: 'requiredMaterials', header: 'Required Materials' },
      { field: 'kitResults', header: 'Kit Results' },
      { field: 'swabRestriction', header: 'Swab Restriction' },
      { field: 'redoReason', header: 'Redo Reasons' },
      { field: 'channel1Gene', header: 'Channel 1-Gene' },
      { field: 'channel1File', header: 'Channel 1-File' },
      { field: 'channel1Dye', header: 'Channel 1-Dye' },
      { field: 'channel2Gene', header: 'Channel 2-Gene' },
      { field: 'channel2File', header: 'Channel 2-File' },
      { field: 'channel2Dye', header: 'Channel 2-Dye' },
      { field: 'channel3Gene', header: 'Channel 3-Gene' },
      { field: 'channel3File', header: 'Channel 3-File' },
      { field: 'channel3Dye', header: 'Channel 3-Dye' },
      { field: 'channel4Gene', header: 'Channel 4-Gene' },
      { field: 'channel4File', header: 'Channel 4-File' },
      { field: 'channel4Dye', header: 'Channel 4-Dye' },
      { field: 'channel5Gene', header: 'Channel 5-Gene' },
      { field: 'channel5File', header: 'Channel 5-File' },
      { field: 'channel5Dye', header: 'Channel 5-Dye' },
      { field: 'runProtocol', header: 'Run Protocol (BioRad) / Experiment Setup (AriaDX)' },
      { field: 'thermalProfile', header: 'Thermal Profile (AriaDX)' },
      { field: 'dominantChannel', header: 'Dominant Channel' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'kitImage', header: 'Kit Image' },
      { field: 'kitImageName', header: 'Selected Kit Image' },
      { field: 'processingTime', header: 'Processing Time' },
      { field: 'active', header: 'Active' }
    ]

    //values to be displayed in Max redo dropdown in crud table component
    this.maxRedoValues = [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
    ];

    this.reactionOptionValues = [
      { label: 'Standard', value: 'Standard' },
      { label: 'GCRich', value: 'GCRich' },
      { label: 'BisulfitSample', value: 'BisulfitSample' }
    ]

    this.problemCategoriesCols = [
      { field: 'categoryName', header: 'Category Name' },
      { field: 'displayName', header: 'Display Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: 'Active' }
    ];

    this.problemCols = [
      { field: 'problemName', header: 'Problem' },
      { field: 'category', header: 'Category' },
      { field: 'description', header: 'Description' },
      { field: 'severity', header: 'Severity' },
      { field: 'extProblemCode', header: 'Ext Problem Code' },
      { field: 'standardCode', header: 'Standard Code' },
      { field: 'active', header: 'Active' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' }
    ];


    this.resultProcessCols = [
      { field: 'name', header: 'Process Name' },
      { field: 'mergeGroup', header: 'Merge Group' },
      { field: 'rawDataRequired', header: 'Transfer Raw Data' },
      { field: 'resultFileRequired', header: 'Transfer Result File' },
      { field: 'reportRequired', header: 'Transfer Report' },
      { field: 'metaDataFileRequired', header: 'Meta File Required' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'storageType', header: 'Storage Type' },
      { field: 'storageKey', header: 'Storage Key' },
      { field: 'storageDetail', header: 'Storage Detail'},
      { field: 'containerName', header: 'Container Name' },
      { field: 'active', header: 'Active' }
    ];

    this.resultEngineConfigCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'cycler', header: 'Cycler' },
      { field: 'resultName', header: 'Result Name' },
      { field: 'active', header: 'Active' }
    ];

    this.externalSenderLoginCols = [
      { field: 'puid', header: 'PUID' },
      { field: 'name', header: 'Sender Name' }
    ]

    this.redoReasonCols = [
      { field: 'reasonName', header: 'Reason Name', showInGrid: true },
      { field: 'reasonInfo', header: 'Reason Info', showInGrid: false },
      { field: 'reasonCode', header: 'Reason Code', showInGrid: true },
      { field: 'lab', header: 'Lab', showInGrid: true },
      { field: 'askForChannel', header: 'Ask For Channel', showInGrid: true },
      { field: 'defaultRedoStep', header: 'Default Redo Step', showInGrid: true },
      { field: 'active', header: 'Active', showInGrid: true }
    ];

    this.inboundFileProcessingCols=[
      { field: 'name', header: 'Name', showInGrid: true },
      { field: 'lab', header: 'Lab', showInGrid: true },
      { field: 'handler', header: 'Handler', showInGrid: true },
      { field: 'location', header: 'Location', showInGrid: true },
      { field: 'active', header: 'Active', showInGrid: true }
    ];

    this.workFlowCols=[
      { field: 'workFlowName', header: 'WorkFlow Name', showInGrid: true },
      { field: 'lab', header: 'Lab', showInGrid: true },
      { field: 'workFlowGroup', header: 'WorkFlow Group', showInGrid: true },
      { field: 'product', header: 'Product', showInGrid: true },
      { field: 'controlSchema', header: 'Control Schema', showInGrid: true },
      { field: 'extractionOnly', header: 'Extraction Only', showInGrid: true },
      { field: 'active', header: 'Active', showInGrid: true }
    ];

    this.controlProcessingCols=[
      { field: 'controlConfigurationName', header: 'Control Configuration Name', showInGrid: true },  
      { field: 'lab', header: 'Lab', showInGrid: false },
      { field: 'numberOfPC', header: 'Positive Extracion Control : Number of PC', showInGrid: false },
      { field: 'numberOfNC', header: 'Negative Extracion Control : Number of NC', showInGrid: false },
      { field: 'numberOfPositivePCR', header: 'Positive PCR Control : Number of Positive PCR Control', showInGrid: false },
      { field: 'numberOfNegativePCR', header: 'Negative PCR Control : Number of Negative PCR Control', showInGrid: false },
      { field: 'active', header: 'Active', showInGrid: true }
    ];

     this.batchStatusCols=[
       { field: 'statusName', header: 'Status Name', showInGrid: true },
       { field: 'displayName', header: 'Display Name', showInGrid: true },
       { field: 'lab', header: 'Lab', showInGrid: true },
       { field: 'sortingCriteria', header: 'Sorting Criteria', showInGrid: true },
       { field: 'machineTypes', header: 'Required Machine Type', sort: 'type.name', onChangeEvent: true , showInGrid: true },
       { field: 'workFileType', header: 'Download WorkFile Type' ,showInGrid: true},
       { field: 'finalState', header: 'is final state', showInGrid: true},
       { field: 'active', header: 'is active', showInGrid: true }
     ];
     this.parentageAnalysisCols=[
      { field:'parentageSystemName', header: 'Parentage System Name', showInGrid:true},
      { field:'lab', header: 'Lab',showInGrid: true},
      { field:'markerList', header:'Marker List'},
      { field:'minPairs', header:'Min. pairs'},
      { field:'minMatch', header:'Min. match'},
      { field:'maxMisMatch', header:'Max. misMatch'},
      { field:'coding', header:'Coding'},
      { field:'childProfileInExploitable', header:'Child Profile InExploitable'},
      { field:'active', header:'is active', showInGrid:true}
     ]

    //Service methods
    this._masterDataService.getCountries().subscribe(results => {
      if (!results) {
        return;
      }
      this.countries = results.data;
    });

    this._masterDataService.getLabs(false).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labs = results.data;
        this.labs.forEach(function (lab) {
          if (lab.mix2SeqLabId == 0) {
            lab.mix2SeqLabId = null;
          }
        })
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getBusinessAreas(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active business Areas:", results.data);
        this.baOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active labs:", results.data);
        this.labOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
    this._masterDataService.getMachineTypes(true,null).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active machine types:", results.data);
        this.machineTypesOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getBmsProductName().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("BMS Product names:", results.data);
        this.bmsProductNames = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getPrinters(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active printers:", results.data);
        this.printerOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
    this._masterDataService.getProducts(true, this.selectedLab.lab._id).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active Products:", results.data);
        this.productOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    this._masterDataService.getActiveBufferChemicals(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active Buffer chemicals:", results.data);
        this.bufferChemicalOptions = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

  }

  setColor(status) {
    if (status == 200) {
      return "up"
    } else if (status == 503) {
      return "down"
    } else {
      return null
    }
  }

  onTabChange(event) {
    switch (event.index) {
      case 0:
        {
          this._masterDataService.getBusinessAreas(false).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("business Areas:", results.data);
              this.businessAreas = results.data;
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;
        }
      case 1: {

        if(this.selectedLab && this.selectedLab.lab.businessArea.name == "Applied Genomics") {
          this._masterDataService.getLabsBasedOnSelectedLabForAppliedGenomics(this.selectedLab.lab).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("labs:", results.data);
              this.labs = results.data;
              this.labs.forEach(function (lab) {
                if (lab.mix2SeqLabId == 0) {
                  lab.mix2SeqLabId = null;
                }
              })
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);

            }
          );

        } else {
          this._masterDataService.getLabs(false).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("labs:", results.data);
              this.labs = results.data;
              this.labs.forEach(function (lab) {
                if (lab.mix2SeqLabId == 0) {
                  lab.mix2SeqLabId = null;
                }
              })
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);

            }
          );
        }

        break;
      }
      case 2: {
        this._masterDataService.getMachineTypes(false, this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("MachineTypes:", results.data);
            this.machineTypes = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 3: {
        this._masterDataService.getMachines(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("machines:", results.data);
            this.machines = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 4: {
        this._masterDataService.getPrinters(false).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Printers:", results.data);
            this.printers = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);

          }
        );
        break;
      }
      case 5: {
        this._masterDataService.getCarrierStates().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Process Step:", results.data);
            this.states = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);

          }
        );
        break;
      }
      case 6: {
        this._masterDataService.getSeqConfigs().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Seq Configs:", results.data);
            this.seqConfigs = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 7:
        {
          this._masterDataService.getProducts(false, this.selectedLab.lab._id).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("The products:", results.data);
              this.products = results.data;
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;
        }
      case 8: {
        this._masterDataService.getChemicals().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Chemicals:", results.data);
            this.chemicals = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 9: {
        this.loading = true;
        this._masterDataService.getHealthStatus().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Health:", results);
            this.respose = results;
            this.health = this.respose.payload.dependency;
            this.loading = false;
          },
          error => {
            console.log("Health:", error);
            this.respose = error.error;
            this.health = this.respose.payload.dependency;
            /* This isnt neccessary due to seeing the error status on page
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            */
            this.loading = false;
          }
        );
        break;
      }
      case 10: {
        this._masterDataService.getAccessLog().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Access Log:", results.data);
            this.accessLog = results.data;
          },
          error => {
            console.log("No Logs Found")
            this.accessLog = [];
          }

        );
        break;
      }
      case 11: {
        this._masterDataService.getLibTypes().subscribe(
          results => {
            if (!results) {
              return;
            }
            this.libTypes = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 12: {

        this._masterDataService.getEchoCofigs(false).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Active Echo Configs --> :", results.data);
            this.echoConfigs = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }

      case 13: {

        this._masterDataService.getSalesItemType().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Sales item type configuration --> :", results.data);
            this.sitConfigs = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }

      case 14: {



        this._masterDataService.getStandardPrimer().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Standard Primers --> :", results.data);
            this.standardPrimers = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 15: {
        this._masterDataService.getTemplates().subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Templates :", results.data);
            this.templates = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 16: {
        this._masterDataService.getSenders(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Templates :", results.data);
            this.senders = results.data;
          },
          error => {
            this.templates = [];
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }

      case 17: {
        this._masterDataService.getKits(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Templates kit :", results.data);
            this.kits = results.data;
          },
          error => {
            this.templates = [];
            console.log("Templates kit:", error);
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }

      case 18: {
        this._masterDataService.getProblemCategoriesList(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.problemCategories = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 19: {
        this._masterDataService.getProblemList(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.problem = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 20: {
        this._masterDataService.getResultProcessList(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.resultProcess = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 21: {
        this._masterDataService.getResultConfigList(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.resultConfigList = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
       }
       case 22: {
        this._masterDataService.getManufacturerList(this.selectedLab.lab._id).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.manufacturersList = results.data;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
       }
       case 23: {
        this._masterDataService.getExternalSenderLogins(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.externalSenderLogins = results.data;
          },
          error => {
            this.templates = [];
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
      }
      case 24:
        this._masterDataService.getRedoReasons(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.redoReasons = results.data;
          },
          error => {
            this.redoReasons = [];
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
        case 25:
        this._masterDataService.getInboundFileProcessing(this.selectedLab.lab).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.inboundFileProcessing = results.data;
          },
          error => {
            this.inboundFileProcessing = [];
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
          }
        );
        break;
        case 26:
          this._masterDataService.getWorkFlow(this.selectedLab.lab._id).subscribe(
            results => {
              if (!results) {
                return;
              }
              this.workFlow=results.data;
            },
            error => {
              this.workFlow = [];
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;
        case 27:
          this._masterDataService.getControlConfiguration(this.selectedLab.lab, this.controlType).subscribe(
            results => {
              if (!results) {
                return;
              }
              this.controls = results.data;
            },
            error => {
              this.controls = [];
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;
        case 28:
          this._masterDataService.getBatchStatus(this.selectedLab.lab._id).subscribe(
            results => {
              if (!results) {
                return;
              }
              this.batchStatus = results.data;
            },
            error => {
              this.batchStatus = [];
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;         
        case 29:
          this._masterDataService.getParentageAnalysis(this.selectedLab.lab._id).subscribe(
            results => {
              if (!results) {
                return;
              }
              this.parentageAnalysis = results.data;
              console.log("file result:",this.parentageAnalysis);
            },
            error => {
              this.parentageAnalysis = [];
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
            }
          );
          break;  
    }
  }
}
